import {
  ExportType,
  HideExports,
  ValueGetter,
} from './Utils';

const getValueGetter = (hideExports: HideExports): ValueGetter => {
  let getValue: ValueGetter;
  if (hideExports === HideExports.On) {
    getValue = ({exportStatus}) => {
      if (exportStatus.type === ExportType.WhollyNotExported ||
          exportStatus.type === ExportType.WhollyExported) {
        return exportStatus.value;
      } else {
        return exportStatus.unexportedValue;
      }
    };
  } else {
    getValue = ({exportStatus}) => {
      if (exportStatus.type === ExportType.WhollyExported ||
          exportStatus.type === ExportType.WhollyNotExported) {
        return exportStatus.value;
      } else {
        return exportStatus.totalValue;
      }
    };
  }
  return getValue;
};

export default getValueGetter;
